import { render, staticRenderFns } from "./Hall-of-fame.vue?vue&type=template&id=d482fcd6"
import script from "./Hall-of-fame.vue?vue&type=script&lang=js"
export * from "./Hall-of-fame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports